export default __webpack_public_path__ + "static/media/Erosion ec57eaad01d84151ab422e3a39e3320d.b942daee.md";